<div class="modal-header">
    <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"><i class="feather x"></i></button>
    <h4 class="modal-title" id="myModalLabel">Conversation Settings</h4>
</div>
<div class="modal-body">
    <form>
        <!-- <div class="form-group">
            <label for="conversationName">Conversation name <span class="optional">(optional)</span></label>
            <input type="text" class="form-control" placeholder="Conversation name" autofocus>
        </div>
        <hr> -->
        <!-- <h4>Participants</h4>
        <p>Click on the persons that you like to add/remove to this conversation.</p> -->
        <div class="row">
            <div class="col-sm-6">
                <label>Clients</label><br>
                <div class="chat-user-selection-item">
                    <div class="chat-user-selection-item-wrapper">
                        <div class="chat-user-selection-item-avatar">
                            <div class="avatar avatar-32">
                                <div class="avatar-inicitials">JD</div>
                            </div>  
                        </div>
                        <div class="chat-user-selection-item-info">
                            <div class="name">Christian Gusukuma</div>
                            <div class="position">Owner <button class="btn btn-danger btn-sm" tooltip="Disable notifications" placement="top"><i class="feather bell-off"></i> Disable</button></div>
                        </div>
                    </div>
                </div>
                <div class="chat-user-selection-item">
                    <div class="chat-user-selection-item-wrapper">
                        <div class="chat-user-selection-item-avatar">
                            <div class="avatar avatar-32">
                                <div class="avatar-inicitials">JD</div>
                            </div>  
                        </div>
                        <div class="chat-user-selection-item-info">
                            <div class="name">Christian Gusukuma</div>
                            <div class="position">User <button class="btn btn-success btn-sm" tooltip="Enable notifications" placement="top"><i class="feather bell"></i> Enable</button></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <label>Team Members</label><br>
                <div class="chat-user-selection-item">
                        <div class="chat-user-selection-item-wrapper">
                            <div class="chat-user-selection-item-avatar">
                                <div class="avatar avatar-32">
                                    <div class="avatar-inicitials">JD</div>
                                </div>  
                            </div>
                            <div class="chat-user-selection-item-info">
                                <div class="name">Christian Gusukuma</div>
                                <div class="position">Admin <button class="btn btn-success btn-sm" tooltip="Enable notifications" placement="top"><i class="feather bell"></i> Enable</button></div>
                            </div>
                        </div>
                    </div>
                    <div class="chat-user-selection-item">
                        <div class="chat-user-selection-item-wrapper">
                            <div class="chat-user-selection-item-avatar">
                                <div class="avatar avatar-32">
                                    <div class="avatar-inicitials">JD</div>
                                </div>  
                            </div>
                            <div class="chat-user-selection-item-info">
                                <div class="name">Christian Gusukuma</div>
                                <div class="position">Accountant <button class="btn btn-danger btn-sm" tooltip="Disable notifications" placement="top"><i class="feather bell-off"></i> Disable</button></div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <!-- <hr>
        <h4>Email notifications</h4>
        <label class="checkbox-label">
            <input type="checkbox" checked> I want to receive email notifications on this conversation.
        </label> -->
    </form>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-4 text-left">
            <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Cancel</button>
        </div>
        <div class="col-8">
            <button type="button" class="btn btn-primary">Save changes</button>
        </div>
    </div>
</div>